import type { AuthError } from '@/pages/auth/_components/auth-error';
import { ErrorCode } from '@fluenceur/types';

type Translate = (key: string, fallback?: string) => string;

/** The sign-up code's refusals, said on the code screen in its own words. */
const CODE_ERROR_KEYS: Partial<Record<string, string>> = {
  [ErrorCode.E_BRAND_SIGNUP_CODE_INVALID]: 'signup.verify.errors.invalid',
  [ErrorCode.E_BRAND_SIGNUP_CODE_TOO_MANY_ATTEMPTS]: 'signup.verify.errors.tooManyAttempts',
  [ErrorCode.E_BRAND_SIGNUP_CODE_TOO_MANY_REQUESTS]: 'signup.verify.errors.tooManyCodes',
};

/**
 * The API's refusal as an `AuthError`: a code of the sign-up code by its
 * screen key, any other code by `errors.<code>`, else the server's sentence or
 * the given fallback key.
 */
export function signupAuthError(
  failure: unknown,
  translate: Translate,
  fallbackKey = 'signup.errors.registrationFailed'
): AuthError {
  const response = (failure as { response?: { data?: { code?: string; message?: string } } })
    ?.response;
  const code = response?.data?.code ?? null;
  const serverMessage = response?.data?.message;

  if (code && CODE_ERROR_KEYS[code]) {
    return { message: translate(CODE_ERROR_KEYS[code]!), code };
  }

  const message = code
    ? translate(`errors.${code}`, serverMessage)
    : serverMessage || translate(fallbackKey);

  return { message, code };
}
